<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  <p>
    {{ 'cart.cart-delivery-date-help-modal.description' | translate }}
  </p>
  <ul>
    <li *ngFor="let deliveryHelp of helpText">
      <p class="spacing--margin-none-vertical">
        <b>{{ deliveryHelp.title }}</b>
      </p>
      <p class="spacing--margin-none-vertical">
        {{ deliveryHelp.description }}
      </p>
    </li>
  </ul>
</agr-dialog>
